import { useEffect } from 'react';
import syncNotificationBadge from '@/utils/syncNotificationBadge';
import useAppState from './useAppState';
import useCurrentUser from './useCurrentUser';

export default function useSyncNotificationBadgeOnActive() {
  const appState = useAppState();
  const currentUser = useCurrentUser();

  useEffect(() => {
    if (currentUser && appState === 'active') {
      syncNotificationBadge(
        currentUser?.notification_counts?.unseen_notification_count ?? 0,
      );
    }
  }, [currentUser, appState]);
}
